/** Rota do detalhe de uma versão do modelo da plataforma. */
export const rotaDetalheModelo = (id: number) => `/apps/protocolos-triagem/modelo-plataforma/${id}`
